import React, { Component } from 'react';

import { connect } from 'react-redux';
import * as homeActions from '../../../redux/homeActions';
import * as sideBarActions from '../../../redux/sideBarActions';
import * as fabricCanvasActions from '../../../redux/fabricCanvasActions';
import * as vanillaDesignActions from '../../../redux/vanillaDesignActions';
import { bindActionCreators } from 'redux';
import { Modal } from 'reactstrap';

import './VanillaFinalCheck.scss';
import { string } from '../../../localization';
import * as Constants from '../../../utilities/constants/Constants';
import { Icons } from '../../../utilities';
import PremiumContentLogin from '../PremiumContentLogin/PremiumContentLogin';
import * as api from '../../../services/api';
import combinedStore from '../../../CombinedStore';
import PremiumContentRegister from './PremiumContentRegister';
import {
  getPremiumContentPrice,
  currencyConversion,
  getArrayOfEachPremiumContent
} from '../../../utilities/HelperFunctions/HelperFunctions';

window._adobeStockCallbackResponse = callbackData => {
  combinedStore.dispatch(
    vanillaDesignActions.adobeStockLoggedInCallback(callbackData)
  );
};

class PremiumContentDetails extends Component {
  state = {
    userName: '',
    password: '',
    confirmPassword: '',
    company: '',
    fiscalNumber: '',
    streetAddress: '',
    areaCode: '',
    city: '',
    website: '',
    firstName: '',
    lastName: '',
    position: '',
    email: '',
    phone: '',
    mobile: '',
    checkedNewsLetter: false,
    checkedAuthorize: '',
    selectedCountry: null,
    selectedOptionValue: ''
  };

  loginToAccount = (userName, password, imageSource) => {
    const { dispatchers } = this.props;
    switch (imageSource) {
      case Constants.PATTERN_DESIGN_IMAGE_SOURCE:
        dispatchers.vanillaDesignActions.postPatternDesignloginRequest(
          userName,
          password
        );
        break;
      case Constants.DREAMSTIME_IMAGE_SOURCE:
        dispatchers.vanillaDesignActions.postDreamstimeloginRequest(
          userName,
          password
        );
        break;
      case Constants.VECTEEZY_IMAGE_SOURCE:
        dispatchers.vanillaDesignActions.postVecteezyloginRequest(
          userName,
          password
        );
        break;
      default:
        break;
    }
  };

  registerModalHandler = (state, contentType) => {
    const { dispatchers } = this.props;
    dispatchers.vanillaDesignActions.clearRegisterAccountErrorMessage();
    switch (contentType) {
      case Constants.PATTERN_DESIGN_IMAGE_SOURCE:
        dispatchers.vanillaDesignActions.handleRegisterWindowPattern(state);
        break;
      case Constants.DREAMSTIME_IMAGE_SOURCE:
        dispatchers.vanillaDesignActions.handleRegisterWindowDreamstime(state);
        break;
      case Constants.VECTEEZY_IMAGE_SOURCE:
        window.open(
          'https://www.vecteezy.com/signups/join_premium/hp',
          '_blank'
        );
        break;
      default:
        break;
    }
  };

  closeRegisterModal = () => {
    // this.setState({
    //   openRegisterModalPage:false
    // })
  };

  createAccount = () => {
    const { dispatchers } = this.props;
    const {
      userName,
      password,
      confirmPassword,
      company,
      fiscalNumber,
      streetAddress,
      areaCode,
      city,
      selectedCountry,
      website,
      selectedOptionValue,
      firstName,
      lastName,
      position,
      email,
      phone,
      mobile,
      checkedNewsLetter,
      checkedAuthorize
    } = this.state;

    const userData = {
      username: userName,
      password,
      password_confirmation: confirmPassword,
      company,
      vatNumber: fiscalNumber,
      street: streetAddress,
      zipCode: areaCode,
      city,
      country: selectedCountry,
      website,
      salutation: selectedOptionValue,
      firstName,
      lastName,
      position,
      email,
      phone,
      mobile,
      newsletter: checkedNewsLetter,
      authorize_hp: checkedAuthorize
    };
    dispatchers.vanillaDesignActions.registerAccount(userData);
  };

  countrySelectorHandler = value => {
    this.setState({
      selectedCountry: value.value.id
    });
  };

  isCheckBoxSelectedNewsLetter = () => {
    this.setState(prevState => ({
      checkedNewsLetter: !prevState.checkedNewsLetter
    }));
  };

  isCheckBoxSelectedAuthorize = () => {
    const { checkedAuthorize } = this.state;
    //   this.setState(function (prevState) {
    //     return {
    //         checkedAuthorize: !prevState.checkedAuthorize
    //     };
    // });
    if (!checkedAuthorize) {
      this.setState({
        checkedAuthorize: 'true'
      });
    } else {
      this.setState({
        checkedAuthorize: 'false'
      });
    }
  };

  redirectToAdobePage = () => {
    const url = api.getResourcePrefix();
    const child = window.open(
      `${url}/adobe_stock_api/login?state=designer`,
      '',
      'width=560,height=340,toolbar=0,menubar=0,location=0'
    );
    setTimeout(() => {
      child.focus();
    }, 1000);
  };

  render() {
    const {
      premiumContentList,
      patternDesignUsername,
      loginErrorMessage,
      envData,
      storeData,
      vecteezyLoginWindowIsOpen,
      dreamstimeLoginWindowIsOpen,
      patternDesignLoginwindowIsOpen,
      createAccountSucccess,
      dispatchers,
      dreamstimeUserInfo,
      adobeStockUserInfo,
      handleRegisterWindowDreamstime,
      handleRegisterWindowPattern
    } = this.props;

    const vectSignedIn = envData.has_valid_vecteezy_account;
    const patternLogedIn = envData.has_valid_pattern_design_account;
    const dreamstimeLogedIn = envData.dreamstime_user_logged_in;
    const adobeStockLogedIn = envData.has_valid_adobe_stock_account;

    const vecteezyArray = getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.VECTEEZY_TYPE
    );

    const patternArray = getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.PATTERN_DESIGN_IMAGE_SOURCE
    );

    const dreamstimeArray = getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.DREAMSTIME_TYPE
    );

    const adobeStockArray = getArrayOfEachPremiumContent(
      premiumContentList,
      Constants.ADOBE_STOCK_IMAGE_SOURCE
    );

    // Currency placement
    const currencyPlacement = storeData.placeMsrpCurrency;
    const classForCurrencyPlacement =
      currencyPlacement === Constants.BEFORE_PRICE_KEY
        ? ' currency-before-price'
        : ' currency-after-price';

    return (
      <div>
        <div className='text-wrap'>
          <p className='sub-title pt-3'>{string.PREMIUM_CONTENT_KEY}</p>
          {(vecteezyArray.length > 0 ? !vectSignedIn : false) ||
          (patternArray.length > 0 ? !patternLogedIn : false) ? (
            <span className='meassage'>{string.EACH_ITEM_PRICE_KEY}</span>
          ) : (
            <span className='meassage'>
              {string.formatString(string.COST_DESCRIPTION_MESSAGE_KEY, <br />)}
              {/* {string.COST_DESCRIPTION_MESSAGE_FIRST_PART_KEY}
              <br />
              {string.COST_DESCRIPTION_MESSAGE_SECOND_PART_KEY} */}
            </span>
          )}
        </div>
        <div className='premium-outer-container'>
          <div className='premium-content'>
            {/* Pattrern design array  */}
            {patternArray.map((placing, index) => (
              <div className='premium-content-details'>
                <div
                  className={`details-container ${
                    patternLogedIn ? 'authenticated-content-view' : null
                  }`}
                >
                  {index === 0 ? (
                    <div
                      className={`heading ${
                        patternLogedIn ? 'authenticated-content-view' : null
                      }`}
                    >
                      <div className='image-source'>
                        {' '}
                        {string.PATTERN_DESIGN_TITLE_KEY}
                        {patternLogedIn ? (
                          <div className='overflow-text'>
                            <img
                              className='ml-1 mr-1'
                              src={Icons.signedinContentProvidersIcon}
                              alt='signedIn'
                            />
                            {string.SIGNED_IN_AS_KEY}{' '}
                            {` ${patternDesignUsername}`}
                          </div>
                        ) : null}
                      </div>
                      {!patternLogedIn ? (
                        <div className='overflow-text'>
                          <img
                            className='vecteezy-icon'
                            src={Icons.pattern_design}
                            alt='veceezy'
                          />
                          {string.LOGIN_SUBTITLE_KEY}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className='image-container'>
                    <img
                      className='thumbnail'
                      src={placing.placeable.thumbnailPath}
                      alt='thumbnail'
                    />
                    {placing.placeable.title}
                    {index === 0 ? (
                      <div id='pattern-login-tooltip' className='login-button'>
                        {patternLogedIn ? (
                          <div
                            role='button'
                            tabIndex='0'
                            className='button flow-primary-default'
                            onKeyPress={() => {}}
                            onClick={
                              dispatchers.vanillaDesignActions
                                .postPatternDesignLogoutRequest
                            }
                          >
                            {string.LOGOUT_KEY}
                          </div>
                        ) : (
                          <div className='d-flex'>
                            <div
                              role='button'
                              tabIndex='0'
                              className='button flow-primary-default '
                              onKeyPress={() => {}}
                              onClick={() =>
                                dispatchers.vanillaDesignActions.handlePatternDesignLoginWindow(
                                  true
                                )
                              }
                            >
                              {string.LOGIN_PATTERN_DESIGN_KEY}
                            </div>
                            <button
                              type='button'
                              style={{
                                border: 'none',
                                background: 'none',
                                outline: 'none'
                              }}
                              className='registerContainer'
                              onClick={() =>
                                this.registerModalHandler(
                                  true,
                                  Constants.PATTERN_DESIGN_IMAGE_SOURCE
                                )
                              }
                            >
                              <span className='register'>
                                {string.REGISTER_KEY}
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>
                <div
                  className={`price-details ${
                    patternLogedIn ? 'authenticated-price-view' : null
                  }`}
                >
                  <img src={Icons.premiumContentThumb} alt='premium' />
                  <span>
                    <span className='premium-content-tag'>
                      {string.PREMIUM_CONTENT_KEY}
                    </span>
                    <span className={`price${classForCurrencyPlacement}`}>
                      {' '}
                      <span>
                        {currencyConversion(
                          placing.placeable,
                          storeData.conversionUnitEur,
                          storeData.conversionUnitUsd
                        ).toFixed(2)}
                      </span>
                      <span className='pl-1 pr-1'>
                        {storeData.msrpCurrency}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            ))}

            {/* Dreamstime array */}
            {dreamstimeArray.map((placing, index) => (
              <div className='premium-content-details'>
                <div
                  className={`details-container ${
                    dreamstimeLogedIn ? 'authenticated-content-view' : null
                  }`}
                >
                  {index === 0 ? (
                    <div
                      className={`heading ${
                        dreamstimeLogedIn ? 'authenticated-content-view' : null
                      }`}
                    >
                      <div className='image-source'>
                        {' '}
                        {string.DREAMSTIME_TITLE_KEY}
                        {dreamstimeLogedIn ? (
                          <div className='overflow-text'>
                            <img
                              className='ml-1 mr-1'
                              src={Icons.signedinContentProvidersIcon}
                              alt='signedIn'
                            />
                            {string.SIGNED_IN_AS_KEY} {` ${dreamstimeUserInfo}`}
                          </div>
                        ) : null}
                      </div>
                      {!dreamstimeLogedIn ? (
                        <div className='overflow-text'>
                          <img
                            className='vecteezy-icon'
                            src={Icons.dreamstime_login_logo_lite}
                            alt='dreamstime'
                          />
                          {string.LOGIN_SUBTITLE_KEY}{' '}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className='image-container'>
                    <img
                      className='thumbnail'
                      src={placing.placeable.thumbnailPath}
                      alt='thumbnail'
                    />
                    {placing.placeable.title}
                    {index === 0 ? (
                      <div
                        id='dreamstime-login-tooltip'
                        className='login-button'
                      >
                        {dreamstimeLogedIn ? (
                          <div
                            role='button'
                            tabIndex='0'
                            className='button flow-primary-default'
                            onKeyPress={() => {}}
                            onClick={
                              dispatchers.vanillaDesignActions
                                .postDreamstimeLogoutRequest
                            }
                          >
                            {string.LOGOUT_KEY}
                          </div>
                        ) : (
                          <div className='d-flex'>
                            <div
                              role='button'
                              tabIndex='0'
                              onKeyPress={() => {}}
                              className='button flow-primary-default'
                              onClick={() =>
                                dispatchers.vanillaDesignActions.handleDreamstimeLoginWindow(
                                  true
                                )
                              }
                            >
                              {string.LOGIN_DREAMSTIME_KEY}
                            </div>
                            <button
                              type='button'
                              style={{
                                border: 'none',
                                background: 'none',
                                outline: 'none'
                              }}
                              className='registerContainer'
                              onClick={() =>
                                this.registerModalHandler(
                                  true,
                                  Constants.DREAMSTIME_IMAGE_SOURCE
                                )
                              }
                            >
                              <span className='register'>
                                {string.REGISTER_KEY}
                              </span>
                            </button>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>

                {/* Premium content price */}
                <div
                  className={`price-details ${
                    dreamstimeLogedIn ? 'authenticated-price-view' : null
                  }`}
                >
                  <img src={Icons.premiumContentThumb} alt='premium' />
                  <span>
                    <span className='premium-content-tag'>
                      {string.PREMIUM_CONTENT_KEY}
                    </span>
                    <span className={`price${classForCurrencyPlacement}`}>
                      {' '}
                      <span>
                        {currencyConversion(
                          placing.placeable,
                          storeData.conversionUnitEur,
                          storeData.conversionUnitUsd
                        ).toFixed(2)}
                      </span>
                      <span className='pl-1 pr-1'>
                        {storeData.msrpCurrency}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            ))}

            {/* Adobe Stock array */}
            {adobeStockArray.map((placing, index) => (
              <div className='premium-content-details'>
                <div
                  className={`details-container ${
                    adobeStockLogedIn ? 'authenticated-content-view' : null
                  }`}
                >
                  {index === 0 ? (
                    <div
                      className={`heading ${
                        adobeStockLogedIn ? 'authenticated-content-view' : null
                      }`}
                    >
                      <div className='image-source'>
                        {' '}
                        {string.ADOBE_STOCK_TITLE_KEY}
                        {adobeStockLogedIn ? (
                          <div className='overflow-text'>
                            <img
                              className='ml-1 mr-1'
                              src={Icons.signedinContentProvidersIcon}
                              alt='signedIn'
                            />
                            {string.SIGNED_IN_AS_KEY} {` ${adobeStockUserInfo}`}
                          </div>
                        ) : null}
                      </div>
                      {!adobeStockLogedIn ? (
                        <div className='overflow-text'>
                          <img
                            className='vecteezy-icon'
                            src={Icons.adobe_sign_in_icon}
                            alt='adobe-stock'
                          />
                          {string.SIGNIN_OR_REGISTER_SUBTITLE_KEY}{' '}
                        </div>
                      ) : null}
                    </div>
                  ) : null}
                  <div className='image-container'>
                    <img
                      className='thumbnail'
                      src={placing.placeable.thumbnailPath}
                      alt='thumbnail'
                    />
                    {placing.placeable.title}
                    {index === 0 ? (
                      <div
                        id='adobe-stock-login-tooltip'
                        className='login-button'
                      >
                        {adobeStockLogedIn ? (
                          <div
                            role='button'
                            tabIndex='0'
                            onKeyPress={() => {}}
                            className='button flow-primary-default'
                            onClick={
                              dispatchers.vanillaDesignActions
                                .logOutFromAdobeStock
                            }
                          >
                            {string.LOGOUT_KEY}
                          </div>
                        ) : (
                          <div className='d-flex'>
                            <div
                              role='button'
                              tabIndex='0'
                              onKeyPress={() => {}}
                              className='button flow-primary-default'
                              onClick={() => this.redirectToAdobePage()}
                            >
                              {string.LOGIN_ADOBE_STOCK_KEY}
                            </div>
                          </div>
                        )}
                      </div>
                    ) : null}
                  </div>
                </div>

                {/* Premium content price */}
                <div
                  className={`price-details ${
                    adobeStockLogedIn ? 'authenticated-price-view' : null
                  }`}
                >
                  <img src={Icons.premiumContentThumb} alt='premium' />
                  <span>
                    <span className='premium-content-tag'>
                      {string.PREMIUM_CONTENT_KEY}
                    </span>
                    <span className={`price${classForCurrencyPlacement}`}>
                      {' '}
                      <span>
                        {currencyConversion(
                          placing.placeable,
                          storeData.conversionUnitEur,
                          storeData.conversionUnitUsd
                        ).toFixed(2)}
                      </span>
                      <span className='pl-1 pr-1'>
                        {storeData.msrpCurrency}
                      </span>
                    </span>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='premium-content-total-cost'>
          <span className='total-text'>{string.TOTAL_PRICE_KEY}</span>
          <span className={`${classForCurrencyPlacement} bold`}>
            <span>
              {getPremiumContentPrice(
                premiumContentList,
                storeData.conversionUnitEur,
                storeData.conversionUnitUsd
              ).toFixed(2)}
            </span>
            <span className='pl-1 pr-1'> {storeData.msrpCurrency} </span>
          </span>
        </div>

        {vecteezyLoginWindowIsOpen ? (
          <PremiumContentLogin
            title={string.LOGIN_VECTEEZY_KEY}
            subTitle={string.SIGNIN_OR_REGISTER_SUBTITLE_KEY}
            newAccountHint={string.CONFIRM_VECTEEZY_ACCOUNT_KEY}
            signOrRegBtnName={string.SIGN_UP_NOW_KEY}
            close={dispatchers.vanillaDesignActions.handleVecteezyLoginWindow}
            modalIsOpen={vecteezyLoginWindowIsOpen}
            imageSourceIcon={Icons.vecteezy_logo_icon}
            registerImage={Icons.vecteezy_register_icon}
            imageSource={Constants.VECTEEZY_TYPE}
            login={this.loginToAccount}
            // logout={this.logoutFromPatternDesignAccount}
            loginErrorMessage={loginErrorMessage}
            handleRegisterWindow={this.registerModalHandler}
          />
        ) : null}
        {/* Tooltip for Pattern design login */}
        {/* {patternArray.length > 0 ? (
          <Tooltip
            id='tooltip-inner'
            placement='top'
            isOpen={this.state.patternLoginTooltipIsOpen}
            target={'pattern-login-tooltip'}
          >
            <div>
              {patternLogedIn
                ? string.LOGOUT_KEY
                : string.LOGIN_PATTERN_DESIGN_KEY}
            </div>
          </Tooltip>
        ) : null} */}
        {/* Tooltip for Vecteezy login  */}
        {/* {vecteezyArray.length > 0 ? (
          <Tooltip
            id='tooltip-inner'
            placement='top'
            isOpen={this.state.vecteezyLoginTooltipIsOpen}
            target={'vecteezy-login-tooltip'}
          >
            <div>
              {vectSignedIn ? string.LOGOUT_KEY : string.LOGIN_VECTEEZY_KEY}
            </div>
          </Tooltip>
        ) : null} */}

        {/* Tooltip for Dreamstime login  */}
        {/* {dreamstimeArray.length > 0 ? (
          <Tooltip
            id='tooltip-inner'
            placement='top'
            isOpen={this.state.dreamstimeLoginTooltipIsOpen}
            target={'dreamstime-login-tooltip'}
          >
            <div>
              {dreamstimeLogedIn
                ? string.LOGOUT_KEY
                : string.LOGIN_DREAMSTIME_KEY}
            </div>
          </Tooltip>
        ) : null} */}

        {/* Tooltip for Adobe Stock login  */}
        {/* {adobeStockArray.length > 0 ? (
          <Tooltip
            id="tooltip-inner"
            placement="top"
            isOpen={this.state.adobeStockTooltipIsOpen}
            target={'adobe-stock-login-tooltip'}
          >
            <div>
              {adobeStockLogedIn
                ? string.LOGOUT_KEY
                : string.LOGIN_ADOBE_STOCK_KEY}
            </div>
          </Tooltip>
        ) : null} */}

        {handleRegisterWindowDreamstime && (
          <Modal
            isOpen={handleRegisterWindowDreamstime}
            backdropClassName='openRegister-backdrop'
            modalClassName='openRegister'
          >
            <PremiumContentRegister
              closeRegisterModal={this.registerModalHandler}
              createAccountSucccess={createAccountSucccess}
              login={this.loginToAccount}
              // patternDesignRegisterError={patternDesignRegisterError}
              dreamstimeLoginWindowIsOpen={dreamstimeLoginWindowIsOpen}
              contentType={Constants.DREAMSTIME_IMAGE_SOURCE}
            />
          </Modal>
        )}

        {handleRegisterWindowPattern && (
          <Modal
            isOpen={handleRegisterWindowPattern}
            // backdrop={false}
            modalClassName='openRegister'
            backdropClassName='openRegister-backdrop'
          >
            <PremiumContentRegister
              closeRegisterModal={this.registerModalHandler}
              createAccountSucccess={createAccountSucccess}
              login={this.loginToAccount}
              // patternDesignRegisterError={patternDesignRegisterError}
              dreamstimeLoginWindowIsOpen={dreamstimeLoginWindowIsOpen}
              contentType={Constants.PATTERN_DESIGN_IMAGE_SOURCE}
            />
          </Modal>
        )}

        {patternDesignLoginwindowIsOpen ? (
          <PremiumContentLogin
            title={string.LOGIN_PATTERN_DESIGN_KEY}
            subTitle={string.LOGIN_SUBTITLE_KEY}
            newAccountHint={string.CONFIRM_PATTERN_ACCOUNT_KEY}
            signOrRegBtnName={string.REGISTER_NOW}
            close={
              dispatchers.vanillaDesignActions.handlePatternDesignLoginWindow
            }
            modalIsOpen={patternDesignLoginwindowIsOpen}
            imageSourceIcon={Icons.patternDesignTitleImage}
            registerImage={Icons.patternDesignRegister}
            imageSource={Constants.PATTERN_DESIGN_IMAGE_SOURCE}
            login={this.loginToAccount}
            // logout={this.logoutFromPatternDesignAccount}
            loginErrorMessage={loginErrorMessage}
            handleRegisterWindow={this.registerModalHandler}
          />
        ) : null}

        {dreamstimeLoginWindowIsOpen ? (
          <PremiumContentLogin
            title={string.LOGIN_DREAMSTIME_KEY}
            subTitle={string.LOGIN_SUBTITLE_KEY}
            newAccountHint={string.CONFIRM_DREAMSTIME_ACCOUNT_KEY}
            signOrRegBtnName={string.REGISTER_KEY}
            close={dispatchers.vanillaDesignActions.handleDreamstimeLoginWindow}
            modalIsOpen={dreamstimeLoginWindowIsOpen}
            imageSourceIcon={Icons.dreamstime_login_logo_lite}
            registerImage={Icons.dreamstime_login_icon}
            imageSource={Constants.DREAMSTIME_IMAGE_SOURCE}
            login={this.loginToAccount}
            // logout={this.logoutFromPatternDesignAccount}
            loginErrorMessage={loginErrorMessage}
            handleRegisterWindow={this.registerModalHandler}
          />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeData: state.modal.storeData,
    envData: state.modal.envData,
    patternDesignUsername: state.vanilla.patternDesignUsername,
    loginErrorMessage: state.vanilla.loginError,
    vecteezyLoginWindowIsOpen: state.vanilla.vecteezyLoginWindowIsOpen,
    dreamstimeLoginWindowIsOpen: state.vanilla.dreamstimeLoginWindowIsOpen,
    patternDesignLoginwindowIsOpen:
      state.vanilla.patternDesignLoginwindowIsOpen,
    patternDesignRegisterError: state.vanilla.registerError,
    handleRegisterWindow: state.vanilla.handleRegisterWindow,
    handleRegisterWindowDreamstime:
      state.vanilla.handleRegisterWindowDreamstime,
    handleRegisterWindowPattern: state.vanilla.handleRegisterWindowPattern,
    dreamstimeUserInfo: state.vanilla.dreamstimeUserInfo,
    triggerRedraw: state.sideBar.triggerRedraw,
    adobeStockUserInfo: state.vanilla.adobeStockUserInfo
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      homeActions: bindActionCreators(homeActions, dispatch),
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      vanillaDesignActions: bindActionCreators(vanillaDesignActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PremiumContentDetails);
